import { WSText } from "@wingspanhq/fe-component-library";
import React from "react";

export const EmailSent: React.FC = () => {
  return (
    <>
      <WSText color="gray600" mb="M">
        An email has been sent to your registered e-mail address.
      </WSText>
      <WSText color="gray600">
        Please check your inbox and click on the <b>Verify Your Account</b> link
        to proceed further.
      </WSText>
    </>
  );
};
